import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { Field, Input, Textarea } from '@/components/ui/Field';
import { useCreateFood, useUpdateFood } from '@/hooks/useApi';
import { toast } from '@/components/ui/Toast';
import { api } from '@/lib/api';
const EMPTY = { name: '', description: '', basePrice: 0, imageUrl: '', isActive: true };
export function FoodFormModal({ open, onClose, food }) {
    const { t } = useTranslation();
    const create = useCreateFood();
    const update = useUpdateFood();
    const [form, setForm] = useState(EMPTY);
    const [uploading, setUploading] = useState(false);
    useEffect(() => {
        if (food) {
            setForm({
                name: food.name,
                description: food.description ?? '',
                basePrice: food.basePrice,
                imageUrl: food.imageUrl ?? '',
                isActive: food.isActive,
            });
        }
        else {
            setForm(EMPTY);
        }
    }, [food, open]);
    const upload = async (file) => {
        setUploading(true);
        try {
            const fd = new FormData();
            fd.append('image', file);
            const r = await api.post('/uploads/foods', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            setForm((f) => ({ ...f, imageUrl: r.data.data.imageUrl }));
        }
        catch (e) {
            toast.error(e?.response?.data?.error || 'خطا در آپلود تصویر');
        }
        finally {
            setUploading(false);
        }
    };
    const submit = async () => {
        if (!form.name.trim()) {
            toast.error(t('food.foodName') + ' ' + t('common.submit'));
            return;
        }
        try {
            if (food)
                await update.mutateAsync({ id: food.id, ...form });
            else
                await create.mutateAsync(form);
            toast.success(t('common.save'));
            onClose();
        }
        catch (e) {
            toast.error(e?.response?.data?.error || 'خطا');
        }
    };
    return (_jsx(Modal, { open: open, onClose: onClose, title: food ? t('food.editFood') : t('food.newFood'), size: "lg", footer: _jsxs(_Fragment, { children: [_jsx(Button, { variant: "secondary", onClick: onClose, children: t('common.cancel') }), _jsx(Button, { onClick: submit, loading: create.isPending || update.isPending, children: t('common.save') })] }), children: _jsxs("div", { className: "grid gap-4 sm:grid-cols-2", children: [_jsx(Field, { label: t('food.foodName'), children: _jsx(Input, { value: form.name, onChange: (e) => setForm({ ...form, name: e.target.value }) }) }), _jsx(Field, { label: t('food.basePrice'), children: _jsx(Input, { type: "number", min: 0, step: 1000, value: form.basePrice, onChange: (e) => setForm({ ...form, basePrice: Number(e.target.value) }) }) }), _jsx(Field, { label: t('common.status'), children: _jsxs("label", { className: "flex items-center gap-2 pt-2 text-sm", children: [_jsx("input", { type: "checkbox", checked: form.isActive, onChange: (e) => setForm({ ...form, isActive: e.target.checked }), className: "h-4 w-4 accent-arshe-500" }), t('common.active')] }) }), _jsx("div", { className: "sm:col-span-2", children: _jsx(Field, { label: t('food.description'), children: _jsx(Textarea, { value: form.description, onChange: (e) => setForm({ ...form, description: e.target.value }) }) }) }), _jsx("div", { className: "sm:col-span-2", children: _jsx(Field, { label: t('food.image'), children: _jsxs("div", { className: "flex items-center gap-3", children: [form.imageUrl && _jsx("img", { src: form.imageUrl, alt: "", className: "h-16 w-16 rounded-lg object-cover" }), _jsx(Input, { type: "file", accept: "image/*", disabled: uploading, onChange: (e) => { const f = e.target.files?.[0]; if (f)
                                        upload(f); } })] }) }) })] }) }));
}
